<template>
  <v-runtime-template :template="includeTemp"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'

export default {
  name: 'CommpnPopup',
  components: {
    VRuntimeTemplate
  },
  props: {
  },
  data () {
    return {
      includeHtml: '',
      visible: false,
      videoSrc: '',
      options: {
        height: '100%',
        color: '#ccc',
        opacity: 1,
        size: '.6rem',
        distance: '1rem',
        disableFadeOut: true,
        alwaysVisible: true
      },
      fullpageOptions: {
        licenseKey: '5D25061B-0D0F4A28-952B9FF0-A0E49441',
        navigation: true,
        sectionsColor: ['', '', '#090a0e', '', '#282a39'],
        normalScrollElements: '.popup-open',
        scrollOverflow: true,
        anchors: ['page1', 'page2', 'page3', 'page4', 'page5']
      },
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 18,
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 12
          },
          720: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        watchSlidesVisibility: true
      },
      swiperOption2: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          720: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      speakerSwiperSet: {
        slidesPerView: 3,
        spaceBetween: 120,
        breakpoints: {
          // 2021-03-02 : 사이즈 변경 tablet 옵션 추가 및 수정
          720: {
            slidesPerView: 'auto',
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 36
          }
        },
        navigation: {
          nextEl: '.speaker-list .swiper-next',
          prevEl: '.speaker-list .swiper-prev'
        },
        watchSlidesVisibility: true
      },
      programSwiperSet: {
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
          // 2021-03-02 : tablet 옵션 추가 및 수정
          720: {
            spaceBetween: 80
          },
          1024: {
            spaceBetween: 124
          }
        },
        watchSlidesVisibility: true
      },
      forumSwiperSet: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
          // 2021-03-02 : tablet 옵션 추가 및 수정
          720: {
            slidesPerView: 'auto'
          }
        },
        navigation: {
          nextEl: '.swiper-nav-next',
          prevEl: '.swiper-nav-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        watchSlidesVisibility: true
      },
      basePath: this.getStore('mmpAuth').state.basePath,
      isEnter: this.$route.meta.isEnter,
      loginNm: '',
      wepSets: this.getStore('mmpAuth').state.wepSets,
      loginType: 'L',
      ptptAplTyp: this.getStore('mmpAuth').state.wepSets.ptptAplTyp
    }
  },
  computed: {
    includeTemp () {
      return this.includeHtml
    }
  },
  mounted () {
  },
  async created () {
    this.getEmptyTemplate(this.$route.params.fileNm + '.html')
  },
  methods: {
    getEmptyTemplate (resourceUrl, next) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.firstSubTemplate = res
        this.includeHtml = wepHtmlToString.firstSubTemplate
      })
    },
    closePopup () {
      window.close()
    },
    close () {
      window.close()
    },
    fnForum () {
    },
    async getMainType () {

    },
    async fnLogin () {
    },
    async fnSurvey () {
    },
    fnBrowser () {
      let agent = window.navigator.userAgent.toLowerCase()
      let appName = window.navigator.appName.toLowerCase()
      let isBrowser = this.$t('IS_BROWSER')
      if (isBrowser === 'Y') {
        let wepUrl = window.location.href
        // IE일 경우 엣지 실행
        if ((appName === 'netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
          let param = {'linkUrl': wepUrl, 'targetNm': ''}
          let _this = this
          setTimeout(function () {
            _this.$popup.browserLink(_this.$el, param)
          }, 1000)
        }
      }
    },
    fnFullPageScroll (isScroll) {
      setTimeout(function () {
        try {
          this.fullpage_api.setAllowScrolling(isScroll)
        } catch (e) {
          // alert(e)
        }
      }, 200)
    },
    moveSectionDown () {
      setTimeout(function () {
        try {
          this.fullpage_api.moveSectionDown()
        } catch (e) {
          // alert(e)
        }
      }, 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/Template.vue